<template>
<div class="featureTab">
    <fg-input type="search" :placeholder="$t('button.search')" v-model.lazy="filter.text" addon-left-icon="fa fa-search"></fg-input>

    <SelectList :options="statusOptions" value="0" @select="(val)=>this.filter.statusOption = val" />
    <SelectList :options="lineSearchOptions" value="NOFILTER" @select="(val)=>this.filter.lineOption = val" />
    <SelectList :options="typeSearchOptions" value="NOFILTER" @select="(val)=>this.filter.typeOption = val" />
    <SelectList :options="assignmentOptions" value="0" @select="(val)=>this.filter.assignmentOption = val" />
    <SelectList v-if="$UiConfig('/ui/map/vehicletab/showRealtimeFilter', false)" :options="realtimeStatusOptions" value="0" @select="(val)=>this.filter.realtimeStatusOption = val" />
    <SelectList v-if="$UiConfig('/data/departure/showCourse', false)" :options="tripShortNameOptions" value="NOFILTER" @select="(val) => this.filter.tripShortNameOption = val" />
    <SelectList v-if="vehicleComputerSearchOptions.length > 1" :options="vehicleComputerSearchOptions" value="NOFILTER" @select="(val)=>this.filter.vehicleComputerOption = val" />
    <GroupCallButton :recipients="groupCallRecipients"/>

    <div id="itemListBase" ref="itemListBase" >
      <div id="itemList">
        <template v-for="(i) in this.printedList">
          <MapVehicleEntry class="listItemEntry" :entry="i" :key="keyGen(i.vehicleLabel)" @click="selectedItem"></MapVehicleEntry>
        </template>
      </div>
    </div>
    <p></p>
    <div class="pagination" id="paginat" v-if="totalRows > listLimit">

      <b-pagination
        class="map-pagination"
        v-model="currentPage"
        :total-rows="this.totalRows"
        :per-page="this.listLimit"
        align="right"
        first-number
        last-number
        limit="2">
      </b-pagination>
    </div> 
    <p v-if="$UiConfig('/ui/map/vehicletab/showVehicleCounter', true)" class="vehicleCounter">
      ( {{ totalRows }} )
    </p>
    <transition name="slide">
      <div id="vehicle-slide-in" class="slidein" v-if="item">
        <MapVehicleDetails v-if="this.item" 
          :key="this.item.vehicleId" 
          :itemId="this.item.vehicleId" 
          @hideItemDetails="hideItemDetails" 
          @vehiclesRoute="onVehiclesRoute"
          @routeLines="onRouteLines"
          @vehicleHistoryLoaded="onVehicleHistoryLoaded"
          ></MapVehicleDetails>
      </div>
    </transition>
</div>
</template>
<style scoped lang="scss">
div.featureTab {
  max-height: 100%;
  display: flex;
  flex-direction: column;

  #itemListBase {
    display:flex;
    flex-flow: column;
    overflow: auto;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: stretch;
    justify-content: flex-start;
    align-items: stretch;
  }
}
#itemList {
  flex-grow:4;
}

#paginat {
  order: 99;
}
</style>

<script>
import MapVehicleEntry from '@/components/Map/MapVehicleEntry'
import MapVehicleDetails from '@/components/Map/MapVehicleDetails'
import mapstore from '@/store/map/mapstore'
import utils from '@/plugins/TravellerUtils.js'
import realtime from '@/store/realtime/realtime'
import phone from '@/store/dispatching/phone'
import GroupCallButton from '@/components/Dispatching/VoIP/GroupCallButton'

export default {
  components: {
    MapVehicleEntry,
    MapVehicleDetails ,
    GroupCallButton,
  },
  data: function() {
    return { 
      loading: false,
      dataUpdated: null, 
      startDataUpdate: null,
      vehicleList: null,
      currentPage: 1,
      listLimit:  20,
      item: null,
      realtimeTimerId: null,
      realtimeUpdate: true,
      realtimeUpdateIntervalSec: 3,
      filter: {
        text: "",
        statusOption: "0",
        lineOption: "NOFILTER",
        typeOption: "NOFILTER",
        realtimeStatusOption: "0",
        assignmentOption: "0",
        tripShortNameOption: "NOFILTER",
        vehicleComputerOption: "NOFILTER"
      }
    }
  },
  beforeCreate: function() {
    if (!this.$store.state.mapstore) {
      this.$store.registerModule("mapstore" , mapstore);
    }
    if (!this.$store.state.realtime) {
      this.$store.registerModule("realtime" , realtime);
    }
    if (!this.$store.state.phone) {
      this.$store.registerModule('phone', phone);
    }
  },
  created() {
    if(this.$route.query.vehicleLabel) {
      this.filter.text = this.$route.query.vehicleLabel;
    }
  },
  beforeDestroy: function() {
    this.realtimeUpdate = false;
  },
  watch: {
    filter: {
      deep: true,
      handler(newFilter) {
        this.currentPage = 1;
        this.$store.commit('mapstore/setVehicleFilter',newFilter);
        this.$emit("filterUpdated");
        this.updateData();

        if(newFilter.lineOption != "NOFILTER") {
          this.hideRoutesForMap();
          this.routesForMap();
        } else {
          this.hideRoutesForMap();
    }
  }
    },
    dataUpdated: function() {
      if(!this.realtimeUpdate)
        return;

      let delay = this.realtimeUpdateIntervalSec * 1000;
      if(this.realtimeTimerId == null) 
        this.realtimeTimerId = setTimeout(() => {this.realtimeTimerId = null; this.startDataUpdate = Date.now()}, delay);
    },
    startDataUpdate: function() {
      this.updateData()
    },
    vehiclesForTable: function(newData){ 
      this.dataUpdated = Date.now();
        /* Jos ajoneuvoja ei ole niin ei pollata realiaikadataa suotta */
        if(newData.length <= 0) {
          this.realtimeUpdate = false;
        }
        let lista = JSON.parse(JSON.stringify(newData));
        // Sort vehicle list -> Vehicles with deviation information first
        lista.sort((a, b) => {
          let aActive = false;
          let bActive = false;
          try {
            aActive = Number.isInteger(a.spatialData.properties.deviation);
          }catch(err) {aActive = false;}
          try {
            bActive = Number.isInteger(b.spatialData.properties.deviation);
          }catch(err) {bActive = false;}
          
          if((aActive && bActive ) ||(!aActive && !bActive ))
            return 0;
          if(aActive && !bActive )
            return -1;
          if(!aActive && bActive )
            return 1;
        });
        this.vehicleList = lista;
    }
   
  },
  computed: { 
    statusOptions () {
      return [
        /* { id: '0', label: this.$t("map.vehicles_tab.filter_no_filter"), icon: 'filter' }, */
        { id: '0', label: this.$t("filter.no"), icon: 'filter', caption: this.$t("map.label.schedule_status") },
        { id: '5', label: this.$t("map.vehicles_tab.status_filter_very_early"), icon: 'exclamation-triangle' },
        { id: '3', label: this.$t("map.vehicles_tab.status_filter_ahead"), icon: 'exclamation-triangle' },
        { id: '1', label: this.$t("map.vehicles_tab.status_filter_onschedule"), icon: 'check-circle' },
        { id: '2', label: this.$t("map.vehicles_tab.status_filter_late"), icon: 'x-circle' },
        { id: '4', label: this.$t("map.vehicles_tab.status_filter_very_late"), icon: 'x-circle' },
      ]
      },
      assignmentOptions () {
      return [
        /* { id: "0", label: this.$t("map.vehicles_tab.filter_no_filter"), icon: 'filter' }, */
        { id: "0", icon: 'filter', caption: this.$t("map.label.assignment") },
        { id: "1", label: this.$t("map.vehicles_tab.assignment_filter_assigned"), icon: 'clipboard-check' },
        { id: "2", label: this.$t("map.vehicles_tab.assignment_filter_unassigned"), icon: 'clipboard' },
      ]
      },
      realtimeStatusOptions () {
        /* { id: "0", label: this.$t("map.vehicles_tab.filter_no_filter"), icon: 'filter' }, */
        return [
        { id: "0",  icon: 'filter', caption: this.$t("map.label.realtime_status")  },
        { id: "1", label:  this.$t("map.vehicles_tab.assignment_filter_no_gps"), icon: 'clipboard' },
        { id: "2", label: this.$t("map.vehicles_tab.assignment_filter_unassigned"), icon: 'clipboard' },
        { id: "3", label: this.$t("map.vehicles_tab.assignment_filter_inactive"), icon: 'clipboard' },
        { id: "4", label: this.$t("map.vehicles_tab.assignment_filter_unknown"), icon: 'clipboard' },
      ]
      },
      totalRows() {
        return this.vehicleList ? this.vehicleList.length : 0;
      },
      printedList() {
        let begin = (this.currentPage-1)*this.listLimit;
        let end = begin + this.listLimit;
        return this.vehicleList ? this.vehicleList.slice(begin,end) : [];
      },
      vehicleComputerSearchOptions() {

        let lines = this.$store.getters['mapstore/vehicleComputers'];
        let options = [];
        

        lines.forEach(l => {
          let option = {id: ""+l, label: ""+l, icon: "hdd"};
          options.push(option);
        });
        
        options.sort( (a, b) =>{
          return utils.optionSort(a,b) 
        });
        options.unshift({ id: "NOFILTER", label: this.$t("filter.no"), icon: "filter", caption: this.$t("map.label.vehicle_comp") });
        return options;

      },
      lineSearchOptions() {

        let lines = this.$store.getters['mapstore/runningLines'];
        let options = [];

        lines.forEach(l => {
          let option = {id: ""+l, label: ""+l, icon: "bezier2"};
          options.push(option);
        });
  
        options.sort( (a, b) =>{
          return utils.optionSort(a,b)
        });
      options.unshift({ id: "NOFILTER", label: this.$t("filter.no"), icon: "filter", caption: this.$t("map.label.line_running") });
    
        return options;

      }, 
        tripShortNameOptions() {
            let options = new Set();

            let vehicles = this.vehiclesForTable;
            if (vehicles) {
                vehicles.forEach(vehicle => {
                    try {
                        if (vehicle.spatialData && vehicle.spatialData.properties.tripShortName) {
                            let option = {
                                id: String(vehicle.spatialData.properties.tripShortName),
                                label: String(vehicle.spatialData.properties.tripShortName),
                                icon: null
                            };
                            options.add(option);
                        }
                    } catch {
                        return;
                    }
                });
            }
            let opts = Array.from(options);
            opts.sort((a, b) => {
                return utils.optionSort(a, b)
            });
            opts.unshift({ id: "NOFILTER", label: this.$t("filter.no"), icon: "filter", caption: this.$t("map.label.course") });
            return opts;
        },
      typeSearchOptions() {

        let types = this.$store.getters['realtime/getVehicleTypes'];
        let options = [];
        
        types.forEach(l => {
          let option = {id: ""+l, label: ""+l, icon: null};
          options.push(option);
        });
  
        options.sort( (a, b) =>{
          return utils.optionSort(a,b)
        });
        options.unshift({ id: "NOFILTER", label: this.$t("filter.no"), icon: "filter", caption: this.$t("map.label.vehicle_type") });
        return options;
      }, 
      groupCallRecipients() {
        if( !this.vehicleList )
          return []
        return this.vehicleList.filter( vehicle => {
          return vehicle?.features['SIP_CLIENT_ID']  } )
          .map( vehicle => vehicle.features['SIP_CLIENT_ID'])
      },
      vehiclesForTable() {
        return this.$store.state.mapstore.vehiclesForTable
      }
  },
  mounted: function() {
    this.updateData();
  },
  methods : {
    listOverflows: function() {
      try {
        const elem = this.$refs.itemListBase;
        return elem.scrollHeight > elem.clientHeight;
      }catch(err) {
        return false;
      }
    },
    onRouteLines(routeId) {
    this.$emit("routeLines", routeId);
    },
    tuneListLenght: function() {
      if(this.listOverflows()) {
        this.listLimit = this.listLimit -1;
        setTimeout(this.tuneListLenght,100); 
      }
    },
    selectedItem(tunnus) {
      this.showItemDetails(tunnus);
      this.$emit('itemSelected', this.item);
    },
    async routesForMap() {
      if (this.routesTimerId) {
        clearTimeout(this.routesTimerId);
        this.routesTimerId = null;
      }

      const vehiclesList =  await this.updateData();
      const checkAndProcess = () => {
        if (!this.vehiclesForTable || this.vehiclesForTable.length === 0) {
          this.routesTimerId = setTimeout(checkAndProcess, 300);
          return;
        }
        this.dataUpdated = Date.now();

        vehiclesList.sort((a, b) => {
          const aActive = a.spatialData?.properties?.deviation != null && Number.isInteger(a.spatialData.properties.deviation);
          const bActive = b.spatialData?.properties?.deviation != null && Number.isInteger(b.spatialData.properties.deviation);

          if (aActive === bActive) return 0;
          return aActive ? -1 : 1;
        });

        this.vehicleList = vehiclesList.slice(0, 100);
        this.vehicleList.forEach(vehicle => {
          this.onRouteLines(vehicle.spatialData.properties.routeId);
        });

        this.routesTimerId = null; 
      };
      this.routesTimerId = setTimeout(checkAndProcess, 300);
    },
    hideRoutesForMap: function () {
      this.hideItemDetails();
    },
    showItemDetails(tunnus) {
      let selected = this.vehicleList.filter(i => i.vehicleId == tunnus);
      this.item = selected[0];
    },
    hideItemDetails() {
      this.item = null;
      this.$emit("detailClosed");
    },
    onVehiclesRoute(routeId) { 
      this.$emit("vehiclesRoute", routeId);
    },
    onVehicleHistoryLoaded(selectedDate) {
      this.$emit("vehicleHistoryLoaded", selectedDate);
    }, 
    async updateData() {
      return await this.$store.dispatch('mapstore/getVehiclesForTable', this.realtimeUpdateIntervalSec) 
    },
    keyGen(itemTunnus) {
      return itemTunnus + this.realtimeTimerId;
    }
    /*DEBUG: function() {
      debugger;
    },*/
},
}



</script>

<style scoped lang="scss">

.featureTab {
  max-height: 100%;
}

.vehicleCounter {
  position: relative;
  margin-bottom: -20px !important;
  max-width: fit-content;
  top: 10px;
  padding-right: 10px;
}

.pagination {
  align-items: center;
  max-height: 33px;
  width: fit-content;
  max-width: 230px !important;
  margin: auto;
  margin-bottom: 10px !important;
}
</style>